module.exports = __webpack_public_path__ + "img/Fond_bougies.c2a3525.jpg";